import { registerRootComponent } from 'expo';

// Register background task handlers at app startup — must be before registerRootComponent
// so iOS can find the handler when it wakes the app to deliver background location updates.
import './src/tasks/driveDetection';

import App from './App';

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
